var _rect, _path, _rect2, _path2, _rect3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdZone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 50,
    viewBox: "0 0 57 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.7734,
    y: 19.8916,
    width: 10.2151,
    height: 10.2151,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8174 19.3566L51.6131 2.15234V47.8513L18.8174 31.7222V19.3566Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 19.8916,
    width: 12.9032,
    height: 10.2151,
    rx: 4,
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67773 32.4961C9.67773 30.287 11.4686 28.4961 13.6777 28.4961H15.8631C18.6198 28.4961 20.5502 31.2192 19.6375 33.8204L16.05 44.045C15.589 45.3587 14.3486 46.238 12.9563 46.238C11.1456 46.238 9.67773 44.7702 9.67773 42.9595V32.4961Z",
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.0762,
    width: 2.68817,
    height: 50,
    rx: 1.34409,
    fill: "#FD3B5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83887 20.1309C4.83887 17.9217 6.62973 16.1309 8.83887 16.1309H24.7313V34.4104H8.83887C6.62973 34.4104 4.83887 32.6196 4.83887 30.4104V20.1309Z",
    fill: "#FE3B5B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdZone);
export default __webpack_public_path__ + "static/media/ad-zone.f3421c90c82de2acca5003a0612907dd.svg";
export { ForwardRef as ReactComponent };